import { useMemo } from 'react';
import { buildModel, type DataModel } from '../lib/model';
import { useData } from '../store/data';
import { useFilters } from '../store/filters';

// Baut das Epic-Tree-Modell aus den (ungefilterten) Rows. Der Filter wirkt
// erst beim Rendern, weil die Parent-Kid-Beziehung über alle Daten gehen muss.
// Re-berechnet nur bei echter Änderung von rows oder SP-Faktor.
export function useModel(): DataModel {
  const rows   = useData(s => s.rows);
  const factor = useFilters(s => s.spToPtFactor);
  return useMemo(() => buildModel(rows, factor), [rows, factor]);
}
